import { render, staticRenderFns } from "./updateTuitionType.vue?vue&type=template&id=2b88c50e&"
import script from "./updateTuitionType.vue?vue&type=script&lang=js&"
export * from "./updateTuitionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports